import React, { useState, useEffect } from 'react';
import "../../../Assets/Css/EmpProjectActivity.scss";
import CustomCalendar from '../../../Components/CustomCalendar';
import { getTasks } from '../../../Services/Task/action';
import { getAllAttendance } from '../../../Services/Attendance/action';
import { connect } from 'react-redux';
import moment from 'moment';
import { getLeaves } from '../../../Services/Leave/action';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { customStyle } from '../../../Components/Style';
import { generateYearOptions, Month, activityStyles, activityFilter } from '../../../Lib/utils';
import { useParams } from 'react-router-dom';

const ActivityEmployee = (props) => {
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    Year: '',
    Month: '',
  });
  const Year = generateYearOptions();
  const year = filters?.Year?.value ? parseInt(filters?.Year?.value) : new Date().getFullYear();
  const month = filters?.Month?.value ? new Date(`${filters?.Month?.value} 1, ${year || currentDate.year()}`).getMonth() + 1 : new Date().getMonth() + 1;
  const today = new Date().getDate();
  const { employeeId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      await props?.getTasks();
      await props?.getAllAttendance();
      await props?.getLeaves();
      setLoading(false);
    }

    fetchData();
  }, []);

  const formattedDate = selectedDate?.split(" ")[0];

  const attendanceActivities = Array.isArray(props?.attendance) ? props?.attendance?.filter((item) =>
    (moment(item?.date)?.format('DD-MM-YYYY') === formattedDate) && item?.employee_id == employeeId)?.flatMap((item) => {
      const activityList = [];

      if (item?.clock_in) {
        activityList.push({
          time: item.clock_in,
          type: 'Clock In',
          employeeactivity: 'Ahmedabad (Office)',
        });
      }

      if (item?.clock_out) {
        activityList.push({
          time: item.clock_out,
          type: 'Clock Out',
          employeeactivity: 'Ahmedabad (Office)',
        });
      }


      return activityList;
    }) : [];


  const taskTimerActivities = Array?.isArray(props?.task) ? props?.task?.filter(task =>
    Array.isArray(task?.taskUserMap) && task?.taskUserMap?.some(mapping => mapping?.user_id == employeeId))?.flatMap(task => {

      const timerActivities = task?.taskTimerMap?.filter(item => moment(item?.start_time?.split(" ")?.[0])?.format('DD-MM-YYYY') == formattedDate)?.flatMap(timer => {
        let history = [];
        try {
          history = JSON.parse(timer?.action_history || '[]');
        } catch (err) {
          console.error('Failed to parse action_history:', err);
        }

        return history?.map(actionObj => ({
          time: actionObj?.time?.split(" ")[1],
          type: `${actionObj?.action?.charAt(0).toUpperCase() + actionObj?.action?.slice(1)} Timer`,
          employeeactivity: task?.title,
        }));
      }) || [];

      return timerActivities;
    }) : [];

  const taskActivities = Array?.isArray(props?.task) ? props?.task?.filter(task =>
    Array.isArray(task?.taskUserMap) && task?.taskUserMap?.some(mapping => mapping?.user_id == employeeId))?.flatMap(task => {
      const taskDate = moment(task?.createdAt).format('DD-MM-YYYY');
      if (taskDate !== formattedDate) return [];

      const baseActivity = [];

      baseActivity.push({
        time: task?.createdAt?.split(" ")?.[1],
        type: 'Create Task',
        employeeactivity: task?.title,
      });

      if (task?.status === 'Completed') {
        baseActivity.push({
          time: task?.updated_status_at?.split(" ")?.[1],
          type: 'Complete Task',
          employeeactivity: task?.title,
        });
      }



      return baseActivity;
    }) : [];


  const leaveActivities = Array?.isArray(props?.leave) ? props?.leave?.filter(leave =>
    leave?.employee_id == employeeId)?.flatMap((item) => {
      const activityLeaveList = [];


      if (moment(item?.updatedAt).format('DD-MM-YYYY') === formattedDate && item?.status == "Approved") {
        activityLeaveList.push({
          time: item.updatedAt?.split(' ')[1],
          type: 'Approve Leave',
          employeeactivity: item?.reason,
        });
      }

      if (moment(item?.updatedAt).format('DD-MM-YYYY') === formattedDate && item?.status == "Rejected") {
        activityLeaveList.push({
          time: item.updatedAt?.split(' ')[1],
          type: 'Reject Leave',
          employeeactivity: item?.reason,
        });
      }

      if (moment(item?.createdAt).format('DD-MM-YYYY') === formattedDate) {

        activityLeaveList.push({
          time: item.createdAt?.split(' ')[1],
          type: 'Apply Leave',
          employeeactivity: item?.reason,
        });
      }

      return activityLeaveList;
    }) : []


  const onLeaveActivities = Array?.isArray(props?.leave) ? props?.leave?.filter(leave =>
    (moment(leave?.start_date)?.format('DD-MM-YYYY') === formattedDate) &&
    leave?.employee_id == employeeId &&
    leave?.status == "Approved")?.flatMap((item) => {
      const activityLeaveList = [];

      activityLeaveList.push({
        time: item.updatedAt?.split(' ')[1],
        type: 'On Leave',
        employeeactivity: item?.reason,
      });

      return activityLeaveList;
    }) : []


  const activities = [...attendanceActivities, ...taskActivities, ...taskTimerActivities, ...leaveActivities, ...onLeaveActivities];

  const calculateDaysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  };

  useEffect(() => {
    const days = calculateDaysInMonth(month, year);
    const daysArray = Array.from({ length: days }, (_, index) => {
      const date = new Date(year, month - 1, index + 1);
      return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
    });
    setDaysInMonth(daysArray);

    const todayDate = daysArray.find(day => day.day === today);
    if (todayDate) {
      dayClick(todayDate);
    }
  }, [month, year]);

  const dayClick = (item) => {
    const selectedFullDate = new Date(year, month - 1, item.day);
    const formattedDate = `${item.day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
    const dayName = selectedFullDate.toLocaleDateString('en-US', { weekday: 'long' });

    setSelectedDate(`${formattedDate} - ${dayName}`);
    setSelectedDay(item.day);
  };

  const sortedActivities = activities.sort((a, b) => a.time > b.time ? 1 : -1);

  const groupActivitiesByHour = (activities) => {
    return activities.reduce((acc, activity) => {
      const hour = activity?.time?.split(':')[0];
      if (!acc[hour]) {
        acc[hour] = [];
      }
      acc[hour].push(activity);
      return acc;
    }, {});
  };

  const filteredActivities = selectedFilters.length > 0
    ? sortedActivities.filter((activity) => selectedFilters.includes(activity.type))
    : sortedActivities;

  const groupedActivities = groupActivitiesByHour(filteredActivities);

  const defaultHours = ['09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];

  const toggleFilter = (filter) => {
    setSelectedFilters(prevFilters => {
      if (prevFilters.includes(filter)) {
        return prevFilters.filter((item) => item !== filter);
      } else {
        return [...prevFilters, filter];
      }
    });
  };

  const applyFilters = ({ month, year }) => {
    const currentDate = moment();
    const formattedMonth = new Date(`${month?.value} 1, ${year || currentDate.year()}`).getMonth() + 1

    const days = calculateDaysInMonth(formattedMonth, parseInt(year));
    const daysArray = Array.from({ length: days }, (_, index) => {
      const date = new Date(year, formattedMonth - 1, index + 1);
      return {
        day: index + 1,
        date,
        dayName: date.toLocaleDateString('en-US', { weekday: 'short' })
      };
    });

    setDaysInMonth(daysArray);
  };

  const handleClear = () => {
    setFilters({
      Year: '',
      Month: '',
    })
    const days = calculateDaysInMonth(month, year);
    const daysArray = Array.from({ length: days }, (_, index) => {
      const date = new Date(year, month - 1, index + 1);
      return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
    });
    setDaysInMonth(daysArray);
  }

  return (
    <div className="empActivity-main">
      <div className="row">
        <div className="col-lg-4 col-sm-12">
          <div className="card-type">
            <Select
              value={filters.Month}
              onChange={(data) => {

                setFilters({
                  ...filters,
                  Month: data,
                })
                applyFilters({ month: data, year: year })
              }
              }
              options={Month}
              placeholder={'Month'}
              styles={customStyle}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#5757fe',
                  primary: '#5757fe',
                },
              })}
            />
          </div>
        </div>

        <div className="col-lg-4 col-sm-12">
          <div className="card-type">
            <Select
              value={filters.Year}
              onChange={(data) => {

                setFilters({
                  ...filters,
                  Year: data,
                })
                applyFilters({ month: month, year: data })
              }
              }
              options={Year}
              placeholder={'Year'}
              styles={customStyle}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#5757fe',
                  primary: '#5757fe',
                },
              })}
            />
          </div>
        </div>
        <div className='col-lg-4 col-sm-12'>

          {(filters?.Month || filters?.Year) && (
            <button
              className="export-btn"
              disabled={props.loading}
              onClick={handleClear}
            >
              {props.loading ? (
                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
              ) : (
                'Clear'
              )}
            </button>
          )}
        </div>
      </div>


      {loading ? (
        <Spinner as="span" animation="border" role="status" aria-hidden="true" />
      ) : (
        <div className="activity-table">
          <div className='days-count'>
            <div className='days'>
              {daysInMonth?.map((item, idx) => (
                <div
                  className="days-number"
                  key={idx}
                  onClick={() => dayClick(item)}
                  style={{ cursor: 'pointer', color: selectedDay === item?.day ? 'black' : 'gray' }}
                >
                  {item?.dayName.slice(0, 1)}{item?.day}
                </div>
              ))}
            </div>

            <div className='table-details'>
              <div className='days'>
                {selectedDate && (
                  <div className="selected-date" style={{ gridColumn: 'span ' + daysInMonth.length }}>
                    {selectedDate}
                  </div>
                )}
              </div>

              <div>
                {defaultHours?.map((hour) => (
                  <div className='days' key={hour}>
                    <div className='timer-time'>
                      <span>{hour}:00</span>
                    </div>
                    <div className='d-flex gap-3'>
                      {groupedActivities[hour]?.length > 0 ? (
                        groupedActivities[hour].map((activity, index) => (
                          <div className='timer-activity' key={index} style={{ backgroundColor: activityStyles[activity?.type]?.backgroundColor }}>
                            <div className="activity-container">
                              <span className='dot' style={{ backgroundColor: activityStyles[activity?.type]?.dotColor }}></span>
                              <span className='activity-time'>{activity?.type}</span>
                              <span className='time'>{activity?.time}</span>
                              <span className='task'>{activity?.employeeactivity}</span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div style={{ flexGrow: 1 }}></div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="activity-filter">
                {activityFilter?.map((activity) => (
                  <div
                    key={activity}
                    className={`filter-item ${selectedFilters?.includes(activity) ? 'selected' : ''}`}
                    onClick={() => toggleFilter(activity)}
                    style={{ cursor: 'pointer' }}
                  >
                    <span
                      className="filter-dot"
                      style={{ backgroundColor: activityStyles[activity]?.dotColor }}
                    ></span>
                    <span className="filter-text">{activity}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    task: state.taskReducer.task,
    attendance: state.attendanceReducer.attendance,
    leave: state.leaveReducer.leave
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getTasks: () => {
      dispatch(getTasks())
    },
    getAllAttendance: () => {
      dispatch(getAllAttendance())
    },
    getLeaves: () => {
      dispatch(getLeaves())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ActivityEmployee);